import { createContext } from "react";
import { Transcriptions } from "../models/GetTranscription";

export const TranscriptionContext = createContext<Transcriptions | null>(null)